import { db } from '../database/firebase';
import { collection, getDocs, query, orderBy, limit, where } from 'firebase/firestore';
import { apiGet, apiGetAllPages, useApiData } from './apiClient';

const TICKETS_COLLECTION = 'tickets';

/**
 * @param {{
 *   eventID?: string,
 *   stockID?: string,
 *   pnr?: string,
 *   q?: string,
 *   apiFilters?: Record<string, string>,
 *   page?: number,
 *   perPage?: number,
 *   fetchAll?: boolean,
 * }} opts
 * @returns {Promise<{ data: Array, total: number, page: number, perPage: number } | Array>}
 */
export const getTickets = async ({
  eventID,
  stockID,
  pnr,
  q = '',
  apiFilters = {},
  page = 1,
  perPage = 50,
  fetchAll = false,
} = {}) => {
  if (useApiData) {
    const qs = new URLSearchParams();
    qs.set('sort', 'created');
    qs.set('order', 'desc');

    if (pnr) qs.set('pnr', pnr);
    if (eventID && !stockID) qs.set('event.id', eventID);
    if (stockID) qs.set('event.stockID', stockID);
    if (q?.trim()) qs.set('q', q.trim());

    Object.entries(apiFilters || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        qs.set(key, String(value));
      }
    });

    if (fetchAll) {
      return apiGetAllPages('tickets', qs);
    }

    qs.set('page', String(page));
    qs.set('perPage', String(Math.min(Math.max(perPage, 1), 100)));
    const res = await apiGet(`tickets?${qs.toString()}`);
    return {
      data: res?.data ?? [],
      total: res?.total ?? 0,
      page: res?.page ?? page,
      perPage: res?.perPage ?? perPage,
    };
  }

  const collectionRef = collection(db, TICKETS_COLLECTION);

  let firestoreQ;
  if (eventID && !stockID) {
    firestoreQ = query(collectionRef, orderBy('created', 'desc'), where('event.id', '==', eventID));
  } else if (stockID) {
    firestoreQ = query(
      collectionRef,
      orderBy('created', 'desc'),
      where('event.stockID', '==', stockID),
    );
  } else {
    firestoreQ = query(collectionRef, orderBy('created', 'desc'), limit(100));
  }

  const snap = await getDocs(firestoreQ);
  const rows = [];
  snap?.forEach((docRef) => {
    rows.push({ id: docRef.id, ...docRef.data() });
  });
  if (fetchAll) return rows;
  const start = (page - 1) * perPage;
  return {
    data: rows.slice(start, start + perPage),
    total: rows.length,
    page,
    perPage,
  };
};

export default {
  getTickets,
};
